<template>
  <div class="c-modify">
    <div class="activity-card" v-for="(item, i) in historyFpi.data" :key="i">
      <div class="activity-card-header">
        <span class="c-font-500">
          <i class="el-icon-document c-w-30"></i>
          <span>{{ item.operation }}</span>
          <span v-if="item.memo">（{{ item.memo }}）</span>
        </span>
        <div style="color: #606266;font-size: 14px;">
          <span>
            <i class="el-icon-user"></i>
            {{ item.createUserName }}
          </span>
          <span class="c-m-l-20 c-m-r-15">
            <i class="el-icon-time"></i>
            {{ item.createTime }}
          </span>
        </div>
      </div>
      <div class="activity-card-content">
        <el-table
          class="c-table-border-all"
          :data="item.modifyList"
          style="width: 100%"
          size="mini"
          ref="table"
        >
          <el-table-column
            prop="field"
            label="字段"
            max-width="180"
            show-overflow-tooltip
            :formatter="formatField"
          ></el-table-column>
          <el-table-column
            prop="pfrom"
            label="修改前"
            :formatter="formatFieldValue"
          ></el-table-column>
          <el-table-column
            prop="pto"
            label="修改后"
            :formatter="formatFieldValue"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fields: Array,
    historyFpi: Object,
    fieldsObj: Object,
    dataPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      let field = this.fieldsObj[row.field];
      if (!field) return;
      if (field.frontEndConfig.changeLog_file) {
        cellValue = JSON.parse(cellValue);
        if (Array.isArray(cellValue)) {
          return JSON.stringify(cellValue.map(item => item.url));
        }
      }
      if (cellValue) {
        if (row.field == 'orgIds') {
          return cellValue;
        } else if (!field.frontEndConfig.changeLog_file && this.$util.isJson(cellValue)) {
          cellValue = JSON.parse(cellValue);
        }
      }
      if (field && field.valueOption) {
        if (field.type == 'cascade') {
          if (field.frontEndConfig.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, cellValue);
          } else {
            return this.osg.formatCascade(field.valueOption, cellValue);
          }
        } else if (field.multiple) {
          return this.osg.codelabelForArray(field.valueOption, cellValue);
        } else {
          return this.osg.codelabel(field.valueOption, cellValue);
        }
      } else if (row.field == 'area' || (field && field.type == 'area')) {
        return this.osg.formatArea(cellValue);
      } else if (field.type == 'data') {
        return cellValue.join('，');
      } else {
        return cellValue;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.c-modify {
  .activity-card {
    margin-bottom: 0 !important;
  }
}
</style>
